import { createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "error"
}
const _hoisted_9 = {
  key: 1,
  class: "success"
}
const _hoisted_10 = { class: "form-actions" }
const _hoisted_11 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $props.isOpen,
    title: "Settings",
    onClose: $setup.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers($setup.handleSubmit, ["prevent"]),
        class: "settings-form"
      }, [
        _createVNode($setup["Tabs"], {
          modelValue: $setup.activeTab,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.activeTab) = $event)),
          tabs: $setup.tabs
        }, {
          default: _withCtx(({ active }) => [
            _createCommentVNode(" General Settings Tab "),
            (active === 'general')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode($setup["FormGroup"], {
                    label: "Name",
                    for: "name"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "name",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.form.name) = $event)),
                        type: "text",
                        required: "",
                        disabled: $setup.loading
                      }, null, 8 /* PROPS */, _hoisted_2), [
                        [_vModelText, $setup.form.name]
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode($setup["FormGroup"], { label: "Dark theme" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.form.darkTheme) = $event)),
                        type: "checkbox",
                        onChange: $setup.updateTheme,
                        disabled: $setup.loading
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3), [
                        [_vModelCheckbox, $setup.form.darkTheme]
                      ])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Password Tab "),
            (active === 'password')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode($setup["FormGroup"], {
                    label: "Current Password",
                    for: "currentPassword"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "currentPassword",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.form.currentPassword) = $event)),
                        type: "password",
                        disabled: $setup.loading
                      }, null, 8 /* PROPS */, _hoisted_5), [
                        [_vModelText, $setup.form.currentPassword]
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode($setup["FormGroup"], {
                    label: "New Password",
                    for: "password"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "password",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.form.password) = $event)),
                        type: "password",
                        disabled: $setup.loading
                      }, null, 8 /* PROPS */, _hoisted_6), [
                        [_vModelText, $setup.form.password]
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode($setup["FormGroup"], {
                    label: "Confirm New Password",
                    for: "confirmPassword"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "confirmPassword",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.form.confirmPassword) = $event)),
                        type: "password",
                        disabled: $setup.loading
                      }, null, 8 /* PROPS */, _hoisted_7), [
                        [_vModelText, $setup.form.confirmPassword]
                      ])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        ($setup.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.error), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($setup.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.success), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn-primary",
            disabled: $setup.loading
          }, _toDisplayString($setup.loading ? 'Saving...' : 'Save Changes'), 9 /* TEXT, PROPS */, _hoisted_11)
        ])
      ], 32 /* NEED_HYDRATION */)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-open"]))
}